import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import StockFontList from '../entities/front-stock'
import appconst from '@/lib/appconst';


interface FrontStockState extends ListState<StockFontList> {
    stockmodel: StockFontList,

}

class FrontStockMutations extends ListMutations<StockFontList>{

}
class FrontStock extends ListModule<FrontStockState, any, StockFontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StockFontList>(),
        loading: false,
        stockmodel: StockFontList,
        id:0
    }
    actions = {
        async getAll(context: ActionContext<FrontStockState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontStock/GetStockList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<StockFontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async EditStock(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStock/EditStock', payload.data);
        },
        async supplementStockInfo(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStock/SupplementStockInfo', payload.data);
        },
     
    };
    mutations = {
        setCurrentPage(state: FrontStockState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontStockState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const frontstock = new FrontStock();
export default frontstock;